import { EntityViewModel } from "../core/EntityViewModel";
import { Request } from './request';

export class RequestViewModel extends EntityViewModel<Request> {
    canEditFinishFactDate: boolean;
    requestSpecStatusIdsAllowedForModifying: number[] = [];
}